<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.forecast") + " " + $t("ui.oxt")')
          b-card.mb-2
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-4.col-xl-4.mb-1
                b-input-group(:prepend="$t('ui.league_name')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="league_name"
                    :placeholder='$t("ui.league_name")'
                    v-model="league_name"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="forecastList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(working_date)="row")
                    b-link(@click="redirectTo(row.item, '1X2', 'forecastDetails')") {{ $moment(row.item.working_date).format("YYYY-MM-DD") }}
                  template(v-slot:cell(league_name)="row")
                    span {{ getName(row.item.league_id, 0) }}
                  template(v-slot:cell(home_team_name)="row")
                    span {{ getName(row.item.match_id, 1) }}
                  template(v-slot:cell(away_team_name)="row")
                    span {{ getName(row.item.match_id, 2) }}
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue"
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      league_name: "",
      forecastList: [],
      filter: null,
      sortBy: "working_date",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0,
      match: [],
      league: []
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "working_date",
          label: this.$t("ui.date_time"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "league_name",
          label: this.$t("ui.league_name"),
          sortable: true,
          thClass: "bg-grey",
          thStyle: {
            width: "44%"
          }
        },
        {
          key: "home_team_name",
          label: this.$t("ui.home_team_name"),
          sortable: true,
          thClass: "bg-grey",
          thStyle: {
            width: "20%"
          }
        },
        {
          key: "away_team_name",
          label: this.$t("ui.away_team_name"),
          sortable: true,
          thClass: "bg-grey",
          thStyle: {
            width: "20%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    },
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    redirectTo: function(items, betType, page) {
      this.$store.dispatch("layout/setSubMatch", items)
      this.$store.dispatch("layout/setBetType", betType)
      this.$router.push("/" + page)
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    getName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.league.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.match.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    submit: function() {
      if (!this.$v.$invalid) {
        let bet_type = '1X2'
        let league_name = this.league_name.trim()
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        this.loading = true
        this.$store
          .dispatch("user/getForecastLookup", { bet_type, league_name, page_number, page_size })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data) {
                this.forecastList = response.data
                this.match = response.names.match
                this.league = response.names.league
                this.totalRows = response.data.length > 0 ? this.forecastList[0]["totalrows"] : 0
              } else {
                this.forecastList = []
                this.match = []
                this.league = []
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.forecastList = []
            this.match = []
            this.league = []
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    }
  }
};
</script>

